module.exports = "mutation AddGuest ($userId: Int!, $guest: GuestInput!) {\n  addGuest(userId: $userId, guest: $guest) {\n    id\n  }\n}\n"